import React, { useState, useEffect } from "react";
import {
  FaInstagram,
  FaFacebookF,
  FaWhatsapp,
  FaTelegram,
  FaCalendarAlt,
  FaLinkedinIn,
  FaCog,
  FaLock,
  FaVideo,
  FaArrowLeft
} from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import { CheckCircle } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import {
  disable2FA,
  handleGoogleMeetingConnect,
  initiateFacebookLogin,
  initiateInstagramLogin,
  initiateLinkedinLogin,
  initiatewhatsappLogin,
  twoFaSetup,
  userProfile,
} from "../../../store/user/userThunk";
import {
  igDisconnect,
} from "../../../store/instagram/instagramThunk";
import { FBDisconnect } from "../../../store/facebook/facebookThunk";
import { wpDisconnect } from "../../../store/whatsApp/wpThunks";
import { tgDisconnect } from "../../../store/telegram/telegramThunk";
import LoginWithTeligram from "./LoginWithTeligram"; // Import your Telegram login component
import TwoFactorAuthModal from "../../../components/TwoFactorAuthModal/TwoFactorAuthModal";
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { meetDisconnect } from "../../../store/google/googleThunk";

const SocialMediaSettings = () => {
  // Get profile data from Redux
  const { profile } = useSelector((state) => state.userservice);
  console.log(profile, "profileprofileprofileprofile")
  const { Disconnectmessage } = useSelector((state) => state.instagram);
  const { FbDisconnectmessage } = useSelector((state) => state.facebook);
  const { wpDisconnectmessage } = useSelector((state) => state.whatsapp);
  const { disconnectSuccess } = useSelector((state) => state.google);
  const { tgDisconnectFullfill } = useSelector((state) => state.telegram);
  const [step, setStep] = useState(1);
  
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("social");
  const [showTelegramModal, setShowTelegramModal] = useState(false);
  const [tgStep, setTgStep] = useState(1);
  const [show, setShow] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [disconnectPlatform, setDisconnectPlatform] = useState(null);

  // Fetch user profile data
  useEffect(() => {
    dispatch(userProfile());
  }, [Disconnectmessage, FbDisconnectmessage, wpDisconnectmessage, tgDisconnectFullfill, disconnectSuccess, dispatch]);

  const SocialButton = ({ platform, icon, label, connected, onConnect, onDisconnect }) => (
    <div className="flex flex-col md:flex-row items-start md:items-center justify-between p-4 mb-4 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200">
      <div className="flex items-center w-full md:w-auto mb-3 md:mb-0">
        <div className={`flex items-center justify-center w-10 h-10 md:w-12 md:h-12 rounded-full ${platform === 'instagram' ? 'bg-gradient-to-tr from-purple-500 via-pink-500 to-yellow-500' :
          platform === 'facebook' ? 'bg-blue-600' :
            platform === 'whatsapp' ? 'bg-green-500' :
              platform === 'telegram' ? 'bg-blue-400' :
                platform === 'linkedin' ? 'bg-blue-700' :
                  'bg-red-500'
          } text-white p-2 md:p-3`}>
          {icon}
        </div>
        <span className="ml-3 md:ml-4 font-medium text-gray-800">{label}</span>
      </div>

      <div className="flex items-center w-full md:w-auto justify-end">
        {connected && (
          <CheckCircle className="mr-3 text-green-500 hidden sm:block" size={24} />
        )}
        <button
          onClick={connected ? onDisconnect : onConnect}
          className={`px-3 md:px-4 py-2 rounded-lg font-medium transition-colors duration-200 w-full sm:w-auto ${connected
            ? 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            : `${platform === 'instagram' ? 'bg-[#50b5ff] from-purple-500 to-pink-500' :
              platform === 'facebook' ? 'bg-[#50b5ff]' :
                platform === 'whatsapp' ? 'bg-[#50b5ff]' :
                  platform === 'telegram' ? 'bg-[#50b5ff]' :
                    platform === 'linkedin' ? 'bg-[#50b5ff]' :
                      'bg-[#50b5ff]'
            } text-white hover:opacity-90`
            }`}
        >
          {connected ? (
            <span className="flex items-center justify-center">
              <CheckCircle className="mr-2 text-green-500 sm:hidden" size={16} />
              Disconnect
            </span>
          ) : 'Connect'}
        </button>
      </div>
    </div>
  );


  const handleInstagramLogin = async () => {
    await initiateInstagramLogin();
  };
  const handleFacebookLogin = () => {
    dispatch(initiateFacebookLogin())
  };

  const handleWhatsappLogin = async () => {
    await initiatewhatsappLogin();
  };
  const handlelinkedin = async () => {
    await initiateLinkedinLogin();
  };
  const handleTelegramLogin = async () => {
    setShowTelegramModal(true);
  };

  const handleDisconnectClick = (platform) => {
    setDisconnectPlatform(platform);
    setShowDeleteModal(true);
  };

  const handleInstagramDisconnect = () => {
    dispatch(igDisconnect())
      .unwrap()
      .then(() => toast.success("Instagram disconnected successfully"))
      .catch((error) => toast.error(`Instagram disconnect failed: ${error.message}`));
  };

  const handleConnectMeet = () => {
    handleGoogleMeetingConnect()
  };
  const handleMeetDisconnet = () => {
    dispatch(meetDisconnect())
      .unwrap()
      .then(() => toast.success("Google Meet disconnected"))
      .catch((error) => toast.error(`Google Meet disconnect failed: ${error.message}`));
  };
  const handleFacebookDisconnect = () => {
    dispatch(FBDisconnect())
      .unwrap()
      .then(() => toast.success("Facebook disconnected successfully"))
      .catch((error) => toast.error(`Facebook disconnect failed: ${error.message}`));
  };
  const handleWhatsappDisconnect = () => {
    dispatch(wpDisconnect())
      .unwrap()
      .then(() => toast.success("WhatsApp disconnected successfully"))
      .catch((error) => toast.error(`WhatsApp disconnect failed: ${error.message}`));
  };


  const handleTelegramDisconnet = () => {
    dispatch(tgDisconnect())
      .unwrap()
      .then(() => toast.success("Telegram disconnected successfully"))
      .catch((error) => toast.error(`Telegram disconnect failed: ${error.message}`));
  };


  const TwoFaModelOpen = () => {
    if (profile == null) {
      dispatch(userProfile())
        .unwrap()
        .then((result) => {
          console.log(result, "----result-------")
          if (result?.is2FAEnabled) {
            setStep(3);
            setShow(true)

          } else {
            dispatch(twoFaSetup());
            setStep(1);
            setShow(true)

          }
        })

    } else {
      console.log(profile, "-------ppppp----")
      if (profile?.is2FAEnabled === true) {

        setStep(3);
        setShow(true)

      } else {
        dispatch(twoFaSetup()).unwrap().then((result) => {
          if (result) {

            setStep(1);
            setShow(true)
          }
        })
      }
    }
  };

  let confirmDisable2FA = () => {
    dispatch(disable2FA()).unwrap().then((result) => {
      if (result) {
        dispatch(userProfile())
        Cookies.remove('twofatoken')
        toast.success("2FA verificaion disable successfully")
      }
    });
  }


  const handleDisconnectConfirm = () => {
    if (disconnectPlatform === 'instagram') {
      handleInstagramDisconnect();
    } else if (disconnectPlatform === 'facebook') {
      handleFacebookDisconnect();
    } else if (disconnectPlatform === 'whatsapp') {
      handleWhatsappDisconnect();
    } else if (disconnectPlatform === "2fa") {
      confirmDisable2FA()
    } else if (disconnectPlatform === "google-meet") {
      handleMeetDisconnet()
    }
    // Add more platforms as needed

    setShowDeleteModal(false);
    setDisconnectPlatform(null);
  };


  const handleCancelDisconnect = () => {
    setShowDeleteModal(false);
    setDisconnectPlatform(null);
  };
  return (
    <div className="min-h-screen bg-gray-50 py-4 md:py-8">
      <div className="max-w-6xl mx-auto px-3 md:px-4">
        <div className="mb-4 md:mb-8 bg-[#50b5ff] text-white p-[31px_24px] rounded-[15px]">
          <button
            onClick={() => navigate(-1)} // Navigates to the previous page
            className="text-white hover:text-gray-200 transition-colors duration-200"
            aria-label="Go back"
          >
            <FaArrowLeft size={20} />
          </button>
          <div>
            <h1 className="text-2xl md:text-3xl font-bold text-white ">Account Settings</h1>
            <p className="text-sm md:text-base  mt-1 md:mt-2">Manage your connected accounts and preferences</p>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-sm overflow-hidden">
          {/* Tabs */}
          <div className="flex overflow-x-auto whitespace-nowrap  p-[10px] border-b border-gray-200">
            <button
              onClick={() => setActiveTab("social")}
              className={`flex items-center space-x-1 md:space-x-2 px-3 md:px-6 py-3 md:py-4 font-medium text-xs md:text-sm transition-colors duration-200 ${activeTab === "social"
                ? "border-b-2 border-blue-500 text-[#50B5FF]"
                : "text-gray-600 hover:text-gray-800"
                }`}
            >
              <FaCog size={14} className="flex-shrink-0" />
              <span>Social Media</span>
            </button>

            <button
              onClick={() => setActiveTab("privacy")}
              className={`flex items-center space-x-1 md:space-x-2 px-3 md:px-6 py-3 md:py-4 font-medium text-xs md:text-sm transition-colors duration-200 ${activeTab === "privacy"
                ? "border-b-2 border-blue-500 text-[#50B5FF]"
                : "text-gray-600 hover:text-gray-800"
                }`}
            >
              <FaLock size={14} className="flex-shrink-0" />
              <span>Privacy Settings</span>
            </button>

            <button
              onClick={() => setActiveTab("meeting")}
              className={`flex items-center space-x-1 md:space-x-2 px-3 md:px-6 py-3 md:py-4 font-medium text-xs md:text-sm transition-colors duration-200 ${activeTab === "meeting"
                ? "border-b-2 border-blue-500 text-[#50B5FF]"
                : "text-gray-600 hover:text-gray-800"
                }`}
            >
              <FaVideo size={14} className="flex-shrink-0" />
              <span>Meeting</span>
            </button>
          </div>

          {/* Tab Content */}
          <div className="p-6">
            {activeTab === "social" && (
              <div>
                <div className="mb-6">
                  <h2 className="text-xl font-semibold text-gray-800 mb-1">Social Media Connections</h2>
                  <p className="text-gray-600 text-sm">Connect your social media accounts to enable cross-platform posting</p>
                </div>

                <div className="space-y-4">
                  <SocialButton
                    platform="instagram"
                    icon={<FaInstagram size={24} />}
                    label="Instagram"
                    connected={profile?.iglogin}
                    onConnect={handleInstagramLogin}
                    // onDisconnect={handleInstagramDisconnect}
                    onDisconnect={() => handleDisconnectClick('instagram')}
                  />

                  <SocialButton
                    platform="facebook"
                    icon={<FaFacebookF size={24} />}
                    label="Facebook"
                    connected={profile?.Fblogin}
                    onConnect={handleFacebookLogin}
                    // onDisconnect={handleFacebookDisconnect}
                    onDisconnect={() => handleDisconnectClick('facebook')}

                  />

                  <SocialButton
                    platform="whatsapp"
                    icon={<FaWhatsapp size={24} />}
                    label="WhatsApp Business"
                    connected={profile?.wpLogin}
                    onConnect={handleWhatsappLogin}
                    // onDisconnect={handleWhatsappDisconnect}
                    onDisconnect={() => handleDisconnectClick('whatsapp')}

                  />

                  {/* <SocialButton 
                    platform="telegram"
                    icon={<FaTelegram size={24} />}
                    label="Telegram"
                    connected={profile?.tgLogin}
                    onConnect={handleTelegramLogin}
                    onDisconnect={handleTelegramDisconnet}
                  /> */}

                  {/* <SocialButton 
                    platform="linkedin"
                    icon={<FaLinkedinIn size={24} />}
                    label="LinkedIn"
                    connected={profile?.lilogin}
                    onConnect={handleLinkedinLogin}
                    onDisconnect={() => alert("LinkedIn disconnect not implemented")}
                  /> */}
                </div>
              </div>
            )}

            {activeTab === "privacy" && (
              <div>
                <div className="mb-4 md:mb-6">
                  <h2 className="text-lg md:text-xl font-semibold text-gray-800 mb-1">Privacy Settings</h2>
                  <p className="text-xs md:text-sm text-gray-600">Manage your account security and privacy preferences</p>
                </div>

                <div className="bg-blue-50 border border-blue-100 rounded-lg p-3 md:p-4 mb-4 md:mb-6">
                  <h3 className="font-medium text-gray-800  text-sm md:text-base mb-2">Two-Factor Authentication</h3>
                  <p className="text-gray-600 text-xs md:text-sm mb-3 md:mb-4">Add an extra layer of security to your account by enabling two-factor authentication.</p>
                  {profile?.is2FAEnabled ? (
                    <button
                      className="bg-red-500 text-white px-3 md:px-4 py-1.5 md:py-2 text-sm rounded-lg hover:bg-red-700 transition-colors duration-200"
                      onClick={() => handleDisconnectClick('2fa')} // Replace with your actual disable function
                    >
                      Disable 2FA
                    </button>
                  ) : (
                    <button
                      className="bg-[#50B5FF] text-white px-3 md:px-4 py-1.5 md:py-2 text-sm rounded-lg hover:bg-blue-700 transition-colors duration-200"
                      onClick={() => TwoFaModelOpen()}
                    >
                      Enable 2FA
                    </button>
                  )}
                  <TwoFactorAuthModal setShow={setShow} show={show} setStep={setStep} step={step} />
                </div>

                {/* Additional privacy settings would go here */}
              </div>
            )}

            {activeTab === "meeting" && (
              <div>
                <div className="mb-4 md:mb-6">
                  <h2 className="text-lg md:text-xl font-semibold text-gray-800 mb-1">Meeting Settings</h2>
                  <p className="text-xs md:text-sm text-gray-600">Connect your calendar to schedule meetings</p>
                </div>

                <SocialButton
                  platform="google"
                  icon={<FaCalendarAlt size={24} />}
                  label="Google Calendar"
                  connected={profile?.meetLogin}
                  onConnect={handleConnectMeet}
                  onDisconnect={() => handleDisconnectClick('google-meet')}
                />

                {profile?.googleId && (
                  <div className="mt-4 md:mt-8">
                    <h3 className="font-medium text-gray-800 mb-3 text-sm md:text-base">Calendar Preferences</h3>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
                      <div className="border border-gray-200 rounded-lg p-3 md:p-4">
                        <h4 className="font-medium text-gray-700 mb-2 text-sm md:text-base">Meeting Duration</h4>
                        <select className="w-full border border-gray-300 rounded-lg px-2 md:px-3 py-1.5 md:py-2 text-sm">
                          <option>15 minutes</option>
                          <option>30 minutes</option>
                          <option>45 minutes</option>
                          <option>60 minutes</option>
                        </select>
                      </div>

                      <div className="border border-gray-200 rounded-lg p-3 md:p-4">
                        <h4 className="font-medium text-gray-700 mb-2 text-sm md:text-base">Buffer Time</h4>
                        <select className="w-full border border-gray-300 rounded-lg px-2 md:px-3 py-1.5 md:py-2 text-sm">
                          <option>No buffer</option>
                          <option>5 minutes</option>
                          <option>10 minutes</option>
                          <option>15 minutes</option>
                        </select>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Telegram Login Modal */}
      <LoginWithTeligram
        show6={showTelegramModal}
        handleClose6={() => setShowTelegramModal(false)}
        Tgstep={tgStep}
        setTgstep={setTgStep}
      />


      {showDeleteModal && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-3xl shadow-2xl max-w-md w-full transform animate-in fade-in zoom-in duration-300">
            <div className="p-6 sm:p-8 text-center">
              <div className="w-16 h-16 mx-auto mb-6 bg-red-100 rounded-full flex items-center justify-center">
                <svg className="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 005.656 5.656l1.172-1.172M10.172 13.828a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656L13 7" />
                </svg>

              </div>
              <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3">Disconnect {disconnectPlatform}</h3>
              <p className="text-gray-600 mb-8">Are you sure you want to disconnect {disconnectPlatform}? This action cannot be undone.</p>

              <div className="flex flex-col sm:flex-row gap-3">
                <button
                  onClick={handleCancelDisconnect}
                  className="flex-1 px-6 py-3 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-2xl font-semibold transition-all duration-300 transform hover:scale-105"
                >
                  Cancel
                </button>
                <button
                  onClick={handleDisconnectConfirm}
                  className="flex-1 px-6 py-3 bg-red-500 to-red-600 text-white rounded-2xl font-semibold hover: transition-all duration-300 transform hover:scale-105"
                >
                  Disconnect
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SocialMediaSettings;